import { validatePresenceOf } from '@/shared/utils';

export const validate = address => {
  return validatePresenceOf(address, ['address', 'zipCode', 'city']);
};

export const buildContent = address => {
  var line = `Demeurant ensemble ${address.address}, ${address.zipCode} ${address.city}.`;
  return [line];
};